import { useState, useEffect } from 'react';

const C = {
  bg:      '#F8FDF9',
  dark:    '#0F2D1E',
  primary: '#2D6A4F',
  accent:  '#52B788',
  amber:   '#F59E0B',
  white:   '#FFFFFF',
};

const ff = {
  head: 'Fredoka One, sans-serif',
  body: 'Nunito, sans-serif',
};

const RESPONSIVE_CSS = `
  .mp-nav-desktop { display: flex; align-items: center; gap: 16px; }
  .mp-nav-hamburger { display: none; }
  .mp-hero-inner { flex-direction: row; }
  .mp-hero-phone { display: flex; }
  .mp-how-grid { grid-template-columns: repeat(3, 1fr); }
  .mp-parent-grid { grid-template-columns: repeat(3, 1fr); }
  .mp-kid-grid { grid-template-columns: repeat(3, 1fr); }
  .mp-pricing-grid { grid-template-columns: repeat(2, 1fr); }
  .mp-footer-inner { flex-direction: row; align-items: center; }

  @media (max-width: 768px) {
    .mp-nav-desktop { display: none !important; }
    .mp-nav-hamburger { display: block !important; }
    .mp-hero-inner { flex-direction: column; }
    .mp-hero-phone { display: none !important; }
    .mp-how-grid { grid-template-columns: 1fr !important; }
    .mp-parent-grid { grid-template-columns: 1fr !important; }
    .mp-kid-grid { grid-template-columns: 1fr !important; }
    .mp-pricing-grid { grid-template-columns: 1fr !important; }
    .mp-footer-inner { flex-direction: column; text-align: center; }
  }

  @media (max-width: 1024px) and (min-width: 769px) {
    .mp-parent-grid { grid-template-columns: repeat(2, 1fr) !important; }
    .mp-kid-grid { grid-template-columns: repeat(2, 1fr) !important; }
  }

  .mp-amber-btn {
    display: inline-block;
    background: #F59E0B;
    color: #0F2D1E;
    font-family: 'Nunito', sans-serif;
    font-weight: 800;
    text-decoration: none;
    border-radius: 14px;
    cursor: pointer;
    transition: transform 0.15s, box-shadow 0.15s;
  }
  .mp-amber-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 28px rgba(245,158,11,0.45);
  }
  .mp-outline-btn {
    display: inline-block;
    background: transparent;
    color: #FFFFFF;
    font-family: 'Nunito', sans-serif;
    font-weight: 800;
    text-decoration: none;
    border-radius: 14px;
    border: 2px solid rgba(255,255,255,0.5);
    cursor: pointer;
    transition: border-color 0.15s, background 0.15s;
  }
  .mp-outline-btn:hover {
    border-color: rgba(255,255,255,0.8);
    background: rgba(255,255,255,0.08);
  }
  .mp-free-btn {
    display: block;
    text-align: center;
    border: 2px solid #2D6A4F;
    color: #2D6A4F;
    font-family: 'Nunito', sans-serif;
    font-weight: 800;
    font-size: 15px;
    padding: 13px 24px;
    border-radius: 14px;
    text-decoration: none;
    transition: background 0.15s;
  }
  .mp-free-btn:hover { background: #f0faf4; }
  .mp-pro-btn {
    display: block;
    text-align: center;
    background: #F59E0B;
    color: #0F2D1E;
    font-family: 'Nunito', sans-serif;
    font-weight: 800;
    font-size: 15px;
    padding: 13px 24px;
    border-radius: 14px;
    text-decoration: none;
    transition: transform 0.15s, box-shadow 0.15s;
  }
  .mp-pro-btn:hover { transform: translateY(-1px); box-shadow: 0 6px 20px rgba(245,158,11,0.4); }
  .mp-footer-link { color: rgba(255,255,255,0.6); text-decoration: none; font-family: 'Nunito', sans-serif; font-size: 13px; font-weight: 700; transition: color 0.15s; }
  .mp-footer-link:hover { color: #52B788; }
  .mp-download-btn {
    display: inline-block;
    background: #F59E0B;
    color: #0F2D1E;
    font-family: 'Nunito', sans-serif;
    font-weight: 800;
    font-size: 20px;
    padding: 20px 52px;
    border-radius: 18px;
    text-decoration: none;
    box-shadow: 0 8px 32px rgba(245,158,11,0.4);
    transition: transform 0.15s, box-shadow 0.15s;
  }
  .mp-download-btn:hover { transform: translateY(-3px); box-shadow: 0 16px 48px rgba(245,158,11,0.5); }
`;

export default function MarketingPage() {
  const [scrolled, setScrolled]   = useState(false);
  const [menuOpen, setMenuOpen]   = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    setMenuOpen(false);
  };

  return (
    <>
      <style>{RESPONSIVE_CSS}</style>
      <div style={{ background: C.bg, fontFamily: ff.body, overflowX: 'hidden' }}>

        {/* ── NAV ─────────────────────────────────────────────────── */}
        <nav style={{
          position: 'sticky', top: 0, zIndex: 999,
          background: C.white,
          boxShadow: scrolled ? '0 2px 20px rgba(0,0,0,0.08)' : 'none',
          transition: 'box-shadow 0.25s',
          padding: '0 24px',
        }}>
          <div style={{
            maxWidth: 1100, margin: '0 auto', height: 64,
            display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          }}>
            <div style={{ fontFamily: ff.head, fontSize: 24, color: C.dark, letterSpacing: 0.5 }}>
              🌱 ThriveTrack
            </div>

            {/* Desktop right */}
            <div className="mp-nav-desktop">
              <a href="/app" style={{
                fontFamily: ff.body, fontWeight: 700, fontSize: 14,
                color: C.primary, textDecoration: 'none',
              }}>Log In</a>
              <a
                href="#download"
                className="mp-amber-btn"
                onClick={e => { e.preventDefault(); scrollTo('download'); }}
                style={{ fontSize: 14, padding: '10px 22px' }}
              >
                Download on App Store
              </a>
            </div>

            {/* Hamburger */}
            <button
              className="mp-nav-hamburger"
              onClick={() => setMenuOpen(o => !o)}
              aria-label={menuOpen ? 'Close menu' : 'Open menu'}
              style={{
                background: 'none', border: 'none', cursor: 'pointer',
                fontSize: 22, color: C.dark, padding: 8, lineHeight: 1,
              }}
            >
              {menuOpen ? '✕' : '☰'}
            </button>
          </div>

          {/* Mobile dropdown */}
          {menuOpen && (
            <div style={{
              background: C.white, borderTop: '1px solid #e8f4ed',
              padding: '16px 24px 20px',
            }}>
              <a href="/app" style={{
                display: 'block', padding: '10px 0',
                fontFamily: ff.body, fontWeight: 700, fontSize: 15,
                color: C.primary, textDecoration: 'none',
              }}>Log In</a>
              <a
                href="#download"
                className="mp-amber-btn"
                onClick={e => { e.preventDefault(); scrollTo('download'); }}
                style={{
                  display: 'block', marginTop: 12, textAlign: 'center',
                  fontSize: 15, padding: '13px 20px',
                }}
              >
                Download on App Store
              </a>
            </div>
          )}
        </nav>

        {/* ── HERO ────────────────────────────────────────────────── */}
        <section style={{
          background: C.dark, padding: '80px 24px 96px',
          position: 'relative', overflow: 'hidden',
        }}>
          {/* Decorative orbs */}
          <div style={{ position: 'absolute', top: -100, right: -100, width: 380, height: 380, borderRadius: '50%', background: 'rgba(82,183,136,0.05)', pointerEvents: 'none' }} />
          <div style={{ position: 'absolute', bottom: -120, left: -80, width: 460, height: 460, borderRadius: '50%', background: 'rgba(82,183,136,0.04)', pointerEvents: 'none' }} />

          <div className="mp-hero-inner" style={{
            maxWidth: 1100, margin: '0 auto',
            display: 'flex', alignItems: 'center', gap: 60,
          }}>
            {/* Text */}
            <div style={{ flex: '1 1 420px', minWidth: 0 }}>
              {/* Eyebrow pill */}
              <div style={{
                display: 'inline-block', background: C.amber, color: C.dark,
                borderRadius: 999, padding: '7px 20px',
                fontFamily: ff.body, fontWeight: 800, fontSize: 13,
                marginBottom: 28,
              }}>
                Now Available on the App Store 🎉
              </div>

              <h1 style={{
                fontFamily: ff.head,
                fontSize: 'clamp(34px, 5.5vw, 58px)',
                color: C.white, margin: '0 0 22px', lineHeight: 1.1,
              }}>
                Turn chores into wins<br />your kids actually want.
              </h1>

              <p style={{
                fontFamily: ff.body, fontWeight: 600,
                fontSize: 'clamp(15px, 2.2vw, 18px)',
                color: 'rgba(255,255,255,0.72)',
                margin: '0 0 36px', lineHeight: 1.65, maxWidth: 520,
              }}>
                ThriveTrack gives parents full visibility and kids real motivation. Missions, coins, streaks, and rewards — built for the whole family.
              </p>

              <div style={{ display: 'flex', gap: 14, flexWrap: 'wrap', alignItems: 'center' }}>
                <a
                  href="#download"
                  className="mp-amber-btn"
                  onClick={e => { e.preventDefault(); scrollTo('download'); }}
                  style={{ fontSize: 16, padding: '15px 32px' }}
                >
                  Download Free on App Store
                </a>
                <a
                  href="#how"
                  className="mp-outline-btn"
                  onClick={e => { e.preventDefault(); scrollTo('how'); }}
                  style={{ fontSize: 16, padding: '14px 28px' }}
                >
                  See how it works
                </a>
              </div>

              <p style={{
                fontFamily: ff.body, fontSize: 12,
                color: 'rgba(255,255,255,0.4)', marginTop: 18,
              }}>
                Free to start · No credit card required · Rated 4+
              </p>
            </div>

            {/* Phone mockup */}
            <div className="mp-hero-phone" style={{
              flex: '0 0 auto',
              justifyContent: 'center', alignItems: 'center',
            }}>
              <div style={{
                width: 210, height: 420, background: '#1a3d28',
                borderRadius: 40,
                border: '6px solid rgba(82,183,136,0.25)',
                boxShadow: '0 40px 80px rgba(0,0,0,0.55)',
                display: 'flex', flexDirection: 'column',
                alignItems: 'center', justifyContent: 'center',
                position: 'relative', overflow: 'hidden',
              }}>
                {/* Accent arc top-right */}
                <div style={{
                  position: 'absolute', top: -50, right: -50,
                  width: 160, height: 160, borderRadius: '50%',
                  border: `3px solid ${C.accent}`, opacity: 0.35,
                  pointerEvents: 'none',
                }} />
                {/* Accent arc bottom-left */}
                <div style={{
                  position: 'absolute', bottom: -35, left: -35,
                  width: 120, height: 120, borderRadius: '50%',
                  border: `2px solid ${C.accent}`, opacity: 0.2,
                  pointerEvents: 'none',
                }} />
                {/* Amber dot */}
                <div style={{
                  position: 'absolute', top: 52, right: 42,
                  width: 11, height: 11, borderRadius: '50%',
                  background: C.amber,
                }} />
                {/* TT monogram */}
                <div style={{
                  fontFamily: ff.head, fontSize: 54, color: C.white,
                  letterSpacing: -2, position: 'relative', zIndex: 1,
                  textShadow: '0 0 40px rgba(82,183,136,0.45)',
                }}>
                  TT
                </div>
                <div style={{
                  fontFamily: ff.head, fontSize: 13, color: C.accent,
                  marginTop: 8, position: 'relative', zIndex: 1,
                }}>
                  ThriveTrack
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ── HOW IT WORKS ────────────────────────────────────────── */}
        <section id="how" style={{ background: C.white, padding: '88px 24px' }}>
          <div style={{ maxWidth: 1100, margin: '0 auto' }}>
            <div style={{ textAlign: 'center', marginBottom: 56 }}>
              <div style={{
                fontFamily: ff.body, fontWeight: 800, fontSize: 11,
                letterSpacing: 2.5, color: C.accent, textTransform: 'uppercase', marginBottom: 14,
              }}>
                HOW IT WORKS
              </div>
              <h2 style={{
                fontFamily: ff.head, fontSize: 'clamp(26px, 4.5vw, 40px)',
                color: C.dark, margin: 0,
              }}>
                Simple for parents. Fun for kids.
              </h2>
            </div>

            <div className="mp-how-grid" style={{ display: 'grid', gap: 24 }}>
              {[
                {
                  num: '1',
                  title: 'Parents create missions',
                  body: 'Set tasks, assign coin values, schedule by day. Full control from a clean dashboard.',
                },
                {
                  num: '2',
                  title: 'Kids complete and earn',
                  body: 'Streaks, XP levels, badges and journals keep kids engaged every single day.',
                },
                {
                  num: '3',
                  title: 'Approve and reward',
                  body: 'One-tap approvals, real allowance payouts, and family celebrations.',
                },
              ].map(({ num, title, body }) => (
                <div key={num} style={{
                  background: C.bg, borderRadius: 24, padding: '36px 28px',
                  border: '1.5px solid #d4eadb',
                }}>
                  <div style={{
                    width: 50, height: 50, borderRadius: 16,
                    background: C.dark, display: 'flex',
                    alignItems: 'center', justifyContent: 'center',
                    fontFamily: ff.head, fontSize: 22, color: C.white,
                    marginBottom: 20,
                  }}>
                    {num}
                  </div>
                  <div style={{ fontFamily: ff.head, fontSize: 19, color: C.dark, marginBottom: 10 }}>{title}</div>
                  <div style={{ fontFamily: ff.body, fontSize: 14, color: '#5a7a6a', lineHeight: 1.7 }}>{body}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ── PARENT FEATURES ─────────────────────────────────────── */}
        <section style={{ background: C.bg, padding: '88px 24px' }}>
          <div style={{ maxWidth: 1100, margin: '0 auto' }}>
            <div style={{ textAlign: 'center', marginBottom: 56 }}>
              <div style={{
                fontFamily: ff.body, fontWeight: 800, fontSize: 11,
                letterSpacing: 2.5, color: C.accent, textTransform: 'uppercase', marginBottom: 14,
              }}>
                FOR PARENTS
              </div>
              <h2 style={{
                fontFamily: ff.head, fontSize: 'clamp(26px, 4.5vw, 40px)',
                color: C.dark, margin: 0,
              }}>
                Everything a parent needs
              </h2>
            </div>

            <div className="mp-parent-grid" style={{ display: 'grid', gap: 20 }}>
              {[
                { emoji: '📊', title: 'Real-time dashboard',  body: "See every child's progress, mood, and earnings at a glance." },
                { emoji: '✅', title: 'One-tap approvals',    body: 'Quickly approve or reject completed tasks right from your phone.' },
                { emoji: '💰', title: 'Allowance tracker',    body: 'Automatically track earned coins and real dollar payouts.' },
                { emoji: '📣', title: 'Parent shoutouts',     body: 'Send encouraging shoutouts that kids see on their dashboard.' },
                { emoji: '🏁', title: 'Family challenges',    body: 'Create friendly competitions to keep the whole family motivated.' },
                { emoji: '🔁', title: 'Mission templates',    body: '50+ pre-built missions across chores, school, self-care and more.' },
              ].map(({ emoji, title, body }) => (
                <div key={title} style={{
                  background: C.white, borderRadius: 20, padding: '28px 24px',
                  border: '1.5px solid #d4eadb',
                  boxShadow: '0 2px 12px rgba(15,45,30,0.04)',
                }}>
                  <div style={{ fontSize: 36, marginBottom: 14 }}>{emoji}</div>
                  <div style={{ fontFamily: ff.head, fontSize: 17, color: C.dark, marginBottom: 8 }}>{title}</div>
                  <div style={{ fontFamily: ff.body, fontSize: 13, color: '#5a7a6a', lineHeight: 1.7 }}>{body}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ── KID FEATURES ────────────────────────────────────────── */}
        <section style={{ background: C.dark, padding: '88px 24px' }}>
          <div style={{ maxWidth: 1100, margin: '0 auto' }}>
            <div style={{ textAlign: 'center', marginBottom: 48 }}>
              <div style={{
                fontFamily: ff.body, fontWeight: 800, fontSize: 11,
                letterSpacing: 2.5, color: C.accent, textTransform: 'uppercase', marginBottom: 14,
              }}>
                FOR KIDS
              </div>
              <h2 style={{
                fontFamily: ff.head, fontSize: 'clamp(26px, 4.5vw, 40px)',
                color: C.white, margin: '0 0 12px',
              }}>
                Kids actually love it.
              </h2>
              <p style={{
                fontFamily: ff.body, fontSize: 16, color: C.accent,
                fontWeight: 600, margin: 0,
              }}>
                Not just a chore app. Built like a game.
              </p>
            </div>

            {/* Feature pills */}
            <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', justifyContent: 'center', marginBottom: 52 }}>
              {[
                '⚡ XP & Levels',
                '🔥 Daily Streaks',
                '🎁 Surprise Missions',
                '🏆 Sibling Leaderboard',
              ].map(pill => (
                <div key={pill} style={{
                  background: C.amber, color: C.dark,
                  borderRadius: 999, padding: '10px 22px',
                  fontFamily: ff.body, fontWeight: 800, fontSize: 14,
                }}>
                  {pill}
                </div>
              ))}
            </div>

            {/* Dark cards */}
            <div className="mp-kid-grid" style={{ display: 'grid', gap: 20 }}>
              {[
                { emoji: '📓', title: 'Journal',         body: 'Kids write about their day. Parents can react with hearts and leave kind notes.' },
                { emoji: '😊', title: 'Mood Check-in',   body: 'Daily check-ins help kids build emotional awareness — and give parents real insight.' },
                { emoji: '🛡️', title: 'Streak Shields',  body: 'Miss a day? Streak shields protect progress and keep motivation alive.' },
              ].map(({ emoji, title, body }) => (
                <div key={title} style={{
                  background: 'rgba(255,255,255,0.07)', borderRadius: 20, padding: '28px 24px',
                  border: '1px solid rgba(82,183,136,0.2)',
                }}>
                  <div style={{ fontSize: 36, marginBottom: 14 }}>{emoji}</div>
                  <div style={{ fontFamily: ff.head, fontSize: 18, color: C.white, marginBottom: 8 }}>{title}</div>
                  <div style={{ fontFamily: ff.body, fontSize: 13, color: 'rgba(255,255,255,0.65)', lineHeight: 1.7 }}>{body}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ── PRICING ─────────────────────────────────────────────── */}
        <section style={{ background: C.white, padding: '88px 24px' }}>
          <div style={{ maxWidth: 860, margin: '0 auto' }}>
            <div style={{ textAlign: 'center', marginBottom: 56 }}>
              <div style={{
                fontFamily: ff.body, fontWeight: 800, fontSize: 11,
                letterSpacing: 2.5, color: C.accent, textTransform: 'uppercase', marginBottom: 14,
              }}>
                PRICING
              </div>
              <h2 style={{
                fontFamily: ff.head, fontSize: 'clamp(26px, 4.5vw, 40px)',
                color: C.dark, margin: 0,
              }}>
                Start free. Upgrade when you're ready.
              </h2>
            </div>

            <div className="mp-pricing-grid" style={{ display: 'grid', gap: 24 }}>
              {/* Free tier */}
              <div style={{
                background: C.white, borderRadius: 24, padding: '36px 28px',
                border: '2px solid #d4eadb',
              }}>
                <div style={{ fontFamily: ff.head, fontSize: 22, color: C.dark, marginBottom: 8 }}>Free</div>
                <div style={{ fontFamily: ff.head, fontSize: 52, color: C.dark, marginBottom: 4, lineHeight: 1 }}>$0</div>
                <div style={{ fontFamily: ff.body, fontSize: 13, color: '#5a7a6a', marginBottom: 28 }}>Forever free</div>
                <ul style={{ listStyle: 'none', padding: 0, margin: '0 0 32px', display: 'flex', flexDirection: 'column', gap: 11 }}>
                  {[
                    'Up to 3 children',
                    'Unlimited missions',
                    'Coin & reward system',
                    'Daily mood check-ins',
                    'Streak tracking',
                    'Achievement badges',
                    'Parent approvals',
                    'Basic templates',
                  ].map(f => (
                    <li key={f} style={{ display: 'flex', gap: 10, fontFamily: ff.body, fontSize: 14, color: C.dark }}>
                      <span style={{ color: C.accent, fontWeight: 900, flexShrink: 0 }}>✓</span> {f}
                    </li>
                  ))}
                </ul>
                <a
                  href="#download"
                  className="mp-free-btn"
                  onClick={e => { e.preventDefault(); scrollTo('download'); }}
                >
                  Download Free
                </a>
              </div>

              {/* Pro tier */}
              <div style={{
                background: C.dark, borderRadius: 24, padding: '36px 28px',
                position: 'relative', overflow: 'hidden',
              }}>
                {/* Most Popular badge */}
                <div style={{
                  position: 'absolute', top: 20, right: 20,
                  background: C.amber, color: C.dark,
                  fontFamily: ff.body, fontWeight: 800, fontSize: 12,
                  padding: '4px 14px', borderRadius: 999,
                }}>
                  Most Popular
                </div>

                <div style={{ fontFamily: ff.head, fontSize: 22, color: C.white, marginBottom: 8 }}>Pro ⭐</div>
                <div style={{ fontFamily: ff.head, fontSize: 52, color: C.white, marginBottom: 4, lineHeight: 1 }}>
                  $9.99<span style={{ fontFamily: ff.body, fontSize: 18, fontWeight: 700 }}>/mo</span>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 10 }}>
                  <span style={{ fontFamily: ff.body, fontSize: 13, color: 'rgba(255,255,255,0.55)' }}>or $79.99/yr</span>
                  <span style={{
                    background: C.amber, color: C.dark,
                    fontFamily: ff.body, fontWeight: 800, fontSize: 11,
                    padding: '3px 10px', borderRadius: 999,
                  }}>
                    Save 33%
                  </span>
                </div>
                <div style={{ fontFamily: ff.body, fontSize: 13, color: 'rgba(255,255,255,0.4)', marginBottom: 28 }}>
                  Launching soon — get notified
                </div>

                <ul style={{ listStyle: 'none', padding: 0, margin: '0 0 32px', display: 'flex', flexDirection: 'column', gap: 11 }}>
                  {[
                    'Everything in Free',
                    'Unlimited children',
                    'Family challenges',
                    'Sibling leaderboard',
                    'Parent shoutouts',
                    'Surprise missions',
                    'Advanced analytics',
                    'Mission templates library',
                    'Allowance payout tracker',
                    'Priority support',
                    'Early access features',
                    'Ad-free experience',
                  ].map(f => (
                    <li key={f} style={{ display: 'flex', gap: 10, fontFamily: ff.body, fontSize: 14, color: 'rgba(255,255,255,0.9)' }}>
                      <span style={{ color: C.amber, fontWeight: 900, flexShrink: 0 }}>✓</span> {f}
                    </li>
                  ))}
                </ul>

                <div style={{
                  display: 'block', textAlign: 'center',
                  background: C.amber, color: C.dark,
                  fontFamily: ff.body, fontWeight: 800, fontSize: 15,
                  padding: '13px 24px', borderRadius: 14,
                  opacity: 0.6, cursor: 'default',
                }}>
                  Coming Soon
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ── DOWNLOAD CTA ────────────────────────────────────────── */}
        <section id="download" style={{ background: C.dark, padding: '100px 24px', textAlign: 'center' }}>
          <div style={{ maxWidth: 640, margin: '0 auto' }}>
            <h2 style={{
              fontFamily: ff.head,
              fontSize: 'clamp(30px, 5.5vw, 52px)',
              color: C.white, margin: '0 0 18px', lineHeight: 1.1,
            }}>
              Your family's best year starts now.
            </h2>
            <p style={{
              fontFamily: ff.body, fontWeight: 600, fontSize: 17,
              color: 'rgba(255,255,255,0.68)',
              margin: '0 0 44px', lineHeight: 1.65,
            }}>
              Join families building better habits together.
            </p>

            {/* https://apps.apple.com/app/thrivetrack/id6764627543 */}
            <a
              href="https://apps.apple.com/app/thrivetrack/id6764627543"
              className="mp-download-btn"
              target="_blank"
              rel="noopener noreferrer"
            >
              🍎 Download on the App Store
            </a>

            <p style={{
              fontFamily: ff.body, fontSize: 12,
              color: 'rgba(255,255,255,0.38)', marginTop: 22,
            }}>
              Free to download · 4+ rating · Cancel Pro anytime
            </p>
          </div>
        </section>

        {/* ── FOOTER ──────────────────────────────────────────────── */}
        <footer style={{
          background: C.dark,
          borderTop: '1px solid rgba(82,183,136,0.12)',
          padding: '36px 24px 28px',
        }}>
          <div
            className="mp-footer-inner"
            style={{ maxWidth: 1100, margin: '0 auto', display: 'flex', justifyContent: 'space-between', gap: 20 }}
          >
            <div>
              <div style={{ fontFamily: ff.head, fontSize: 20, color: C.white, marginBottom: 6 }}>
                🌱 ThriveTrack
              </div>
              <div style={{ fontFamily: ff.body, fontSize: 13, color: 'rgba(255,255,255,0.45)' }}>
                Helping families grow together 🌱
              </div>
            </div>
            <div style={{ display: 'flex', gap: 28, alignItems: 'center', flexWrap: 'wrap' }}>
              <a href="/privacy" className="mp-footer-link">Privacy Policy</a>
              <a href="/terms" className="mp-footer-link">Terms of Use</a>
              <a href="/faq" className="mp-footer-link">FAQ</a>
              <a href="mailto:hello@thethrivetrack.com" className="mp-footer-link">Support</a>
            </div>
          </div>
          <div style={{
            maxWidth: 1100, margin: '20px auto 0',
            borderTop: '1px solid rgba(255,255,255,0.07)', paddingTop: 18,
            textAlign: 'center',
          }}>
            <div style={{ fontFamily: ff.body, fontSize: 12, color: 'rgba(255,255,255,0.28)' }}>
              © 2026 Thrive Track LLC. All rights reserved.
            </div>
          </div>
        </footer>

      </div>
    </>
  );
}
